import {
  styled,
  Accordion,
  AccordionProps,
  AccordionSummary,
} from '@mui/material';

export const StyledAccordion = styled((props: AccordionProps) => (
  <Accordion disableGutters elevation={0} square {...props} />
))(() => ({
  elevation: 0,

  '&:before': {
    display: 'none',
  },
}));

export const StyledAccordionSummary = styled(AccordionSummary)({
  '& .MuiAccordionSummary-content': {
    margin: 0,
  },
});
